import React from 'react'
import { RecordingStyles } from '../Style'
import { ReactComponent as MicButton } from 'assets/icons/MicButton.svg'
import { AnimatePresence } from "motion/react"
import * as motion from "motion/react-client"

const Recording = (props) => {
    const { isMaleGender, canvasRef, isTeacherCheck } = props

    return (
            // <motion.div
            //     exit={{ opacity: 0 }}
            //     initial={{ opacity: 0 }}
            //     animate={{ opacity: 1 }}
            //     transition={{ duration: 0.7 }}
            //     key="recording"
            // >
                <RecordingStyles>
                    {isTeacherCheck ?
                    <div>
                        <div className='text1'>{"מקליט..."}</div>
                    </div>
                    :
                    <div>
                        <div className='text1'>{isMaleGender ? "תֹּאמַר בְּקוֹל" : "תֹּאמְרִי בְּקוֹל"}</div>
                        <div className='text2'>{isMaleGender ? "אֲנִי רוֹצֶה לְהַתְחִיל!" : "אֲנִי רוֹצָה לְהַתְחִיל!"}</div>
                    </div>}
                    <canvas
                        ref={canvasRef}
                        width={isTeacherCheck ? 140 : 160}
                        height={isTeacherCheck ? 48 : 58}
                        className="mic-canvas"
                    ></canvas>
                    {isTeacherCheck &&
                        <div className='check-mic-teacher'>
                            <MicButton />
                        </div>}
                </RecordingStyles>
            // </motion.div>
    )
}

export default Recording